import { useState } from "react";
import { Link } from "react-router-dom";

const FORM_URL = "https://readdy.ai/api/form/daeon9ptto0ceqqnh1m0";

const linkGroups: { title: string; links: { label: string; to: string }[] }[] = [
  {
    title: "栏目导航",
    links: [
      { label: "同类盘点", to: "/pandian" },
      { label: "对比分析", to: "/duibi" },
      { label: "系列事件", to: "/shijian" },
      { label: "今日热榜", to: "/" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "常见问题", to: "/faq" },
      { label: "内容原则", to: "/about" },
      { label: "联系编辑", to: "/about" },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<{ type: "success" | "error"; msg: string } | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const hp = String(fd.get("website_alt") || "").trim();
    const mail = String(fd.get("email") || "").trim();

    const okMsg = "订阅成功！每周为你奉上热瓜速报。";
    if (hp) {
      setStatus({ type: "success", msg: okMsg });
      form.reset();
      setEmail("");
      return;
    }
    if (!mail) {
      setStatus({ type: "error", msg: "请先填写你的邮箱地址。" });
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
      setStatus({ type: "error", msg: "邮箱格式似乎不对，请检查后再试。" });
      return;
    }

    setLoading(true);
    setStatus(null);
    const body = new URLSearchParams();
    body.append("email", mail);
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const text = await res.text();
      let code = "";
      let serverMsg = "";
      try {
        const parsed = JSON.parse(text);
        code = parsed?.code || "";
        serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      } catch {
        serverMsg = text || "";
      }
      const ok = res.ok && code === "OK" && !/spam/i.test(serverMsg);
      if (ok) {
        setStatus({ type: "success", msg: okMsg });
        form.reset();
        setEmail("");
      } else {
        setStatus({ type: "error", msg: serverMsg || "订阅失败，请稍后再试。" });
      }
    } catch {
      setStatus({ type: "error", msg: "网络开小差了，请稍后再试。" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto grid max-w-container gap-10 px-4 py-12 md:px-6 md:py-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-radar-line text-lg"></i>
            </span>
            <span className="font-heading text-xl text-background-50">热瓜雷达</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-6 text-background-200/90">
            把全网热瓜同类事件摆在同一张桌上，按时间线串联梳理系列事件与对比分析，相似剧情、后续走向一次摸清。
          </p>
          <div className="mt-5 flex items-center gap-3 text-background-200/90">
            <a href="mailto:editor@regan-radar.example" aria-label="邮箱" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition hover:bg-primary-500 hover:text-background-50">
              <i className="ri-mail-line"></i>
            </a>
            <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition hover:bg-primary-500 hover:text-background-50">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" aria-label="小红书" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition hover:bg-primary-500 hover:text-background-50">
              <i className="ri-remixicon-line"></i>
            </a>
          </div>
        </div>

        {linkGroups.map((group) => (
          <div key={group.title} className="lg:col-span-2">
            <h4 className="text-sm font-semibold text-background-50">{group.title}</h4>
            <ul className="mt-4 space-y-2.5">
              {group.links.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-background-200/90 transition hover:text-primary-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="lg:col-span-4">
          <h4 className="text-sm font-semibold text-background-50">订阅热瓜速报</h4>
          <p className="mt-4 text-sm text-background-200/90">每周三整理当周最值得跟进的系列瓜，直接送到你的邮箱。</p>
          <form data-readdy-form="hotnews-subscribe" onSubmit={onSubmit} className="mt-4 flex flex-col gap-2 sm:flex-row">
            <label htmlFor="foot-mail" className="sr-only">
              邮箱地址
            </label>
            <input
              id="foot-mail"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              className="h-11 w-full rounded-md border border-background-50/20 bg-background-50/10 px-3 text-sm text-background-50 placeholder:text-background-200/50 focus:border-primary-300 focus:outline-none"
            />
            <input
              type="text"
              name="website_alt"
              autoComplete="off"
              tabIndex={-1}
              aria-hidden="true"
              readOnly
              className="hp-trap"
            />
            <button
              type="submit"
              disabled={loading}
              className="h-11 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition hover:bg-primary-400 disabled:opacity-60"
            >
              {loading ? "提交中…" : "立即订阅"}
            </button>
          </form>
          {status && (
            <p
              className={`mt-2 text-xs ${
                status.type === "success" ? "text-secondary-300" : "text-accent-300"
              }`}
              role="status"
            >
              {status.msg}
            </p>
          )}
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex max-w-container flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-background-200/70 sm:flex-row md:px-6">
          <p>© 2026 热瓜雷达 · 仅供娱乐参考，请理性看待网络信息</p>
          <p className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-400"></i> 冷静吃瓜 · 观点中立 · 拒绝网暴
          </p>
        </div>
      </div>
    </footer>
  );
}